import { CASStatus, Permission } from 'shared'
import { useCreateCasCommentMutation } from 'schema'
import { HelpMessage } from 'utils/constants'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { useSubmittalTrackerContext } from '../../../../SubmittalTrackerContext'
import { Submittal } from '../../../../SubmittalTrackerContext/types'

export function useExpandOptions(): ExpandOptions<Submittal> {
  const help = HelpMessage.CAS.SubmittalTracker
  const { refetch, edit } = useSubmittalTrackerContext()
  const [comment] = useCreateCasCommentMutation(DefaultMutationHookOptions)

  return {
    render: ({
      id,
      quantity,
      units,
      comments,
      casToPayItemNoGeometries,
      deleted,
      statusId,
      customFields,
    }) => {
      return {
        additionalInfo: [
          { label: 'Quantity', children: quantity, help: help.Quantity },
          { label: 'Units', children: units, help: help.Units },
          {
            type: 'payItems',
            payItems: casToPayItemNoGeometries.map(({ payItem }) => payItem),
            object: 'Construction & Admin Submittal',
          },
        ],
        comments: {
          comments,
          permission: Permission.CommentOnConstructionAdminSubmittal,
          onSave: async (text) => {
            await comment({ variables: { input: { submittalId: id, text } } })
            refetch()
          },
        },
        customFields: {
          recordInactive: deleted,
          alreadyDisabled:
            statusId === CASStatus.Closed.id
              ? { why: 'invalid status', statusName: CASStatus.Closed.name }
              : false,
          customFields,
          booleanValueOptions: {
            onCheck: async (booleanInput) => {
              await edit({
                id,
                customFields: { booleanInputs: [booleanInput] },
              })
              refetch()
            },
          },
          listValueOptions: {
            onCheck: async (checkbox) => {
              await edit({
                id,
                customFields: { listInputs: { checkboxes: [checkbox] } },
              })
              refetch()
            },
          },
        },
      }
    },
  }
}
